import { render, staticRenderFns } from "./DashboardButtons.vue?vue&type=template&id=648408f4&scoped=true"
import script from "./DashboardButtons.vue?vue&type=script&lang=js"
export * from "./DashboardButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648408f4",
  null
  
)

export default component.exports